<div class="detection-header">
  <h2 mat-dialog-title>{{ 'map.detectionDetails.title' | t }}</h2>
  <button mat-icon-button color="warn" mat-dialog-close [matTooltip]="'common.close' | t">
    <sn-icon fontSet="far" fontIcon="fa-xmark"></sn-icon>
  </button>
</div>
<div class="fs-row">
  <div class="fs-col-8">
    <ng-container *ngIf="isZoomed; else fullImage">
      <canvas class="detectionImg" [id]="canvasId"></canvas>
    </ng-container>
    <ng-template #fullImage>
      <img class="detectionImg" [src]="data.detection.detectionsImageUrl" alt="Detection Image" />
    </ng-template>
  </div>
  <div class="fs-col-4">
    <mat-dialog-content>
      <mat-list>
        <div mat-subheader *ngIf="camera">
          <sn-icon matCardAvatar>videocam</sn-icon>
          {{ 'common.camera' | t }}
        </div>
        <mat-list-item *ngIf="camera">
          <div class="no-truncate" mat-line>{{ camera.name }}</div>
          <div class="no-truncate" *ngIf="camera.location" mat-line>
            {{ camera.location?.name }}
          </div>
        </mat-list-item>
        <mat-divider></mat-divider>
        <ng-container *ngIf="isAvailable">
          <div mat-subheader>
            <sn-icon matCardAvatar>description</sn-icon>
            {{ 'map.detectionDetails.detectionMetadata' | t }}
          </div>
          <ng-container [ngSwitch]="data.detectionFiltered.label">
            <ng-container *ngSwitchCase="'person'">
              <ng-container *ngIf="data.detectionFiltered.metadata?.age">
                <mat-list-item>
                  <div mat-line>
                    {{ 'map.detectionDetails.age' | t }} {{ data.detectionFiltered.metadata?.age?.label?.toUpperCase() }}
                  </div>
                  <div class="propertyName" mat-line>
                    {{ 'common.confidence' | t }}
                    {{ data.detectionFiltered.metadata?.age?.confidence | fsNumber : '1.0-2' }}%
                  </div>
                </mat-list-item>
              </ng-container>
              <ng-container *ngIf="data.detectionFiltered.metadata?.colorTop">
                <mat-list-item>
                  <div mat-line>
                    {{ 'common.topColor' | t }} {{ data.detectionFiltered.metadata?.colorTop?.label?.toUpperCase() }}
                  </div>
                </mat-list-item>
              </ng-container>
              <ng-container *ngIf="data.detectionFiltered.metadata?.colorBottom">
                <mat-list-item>
                  <div mat-line>
                    {{ 'common.bottomColor' | t }}
                    {{ data.detectionFiltered.metadata?.colorBottom?.label?.toUpperCase() }}
                  </div>
                </mat-list-item>
              </ng-container>
              <mat-list-item
                *ngFor="let property of formatFields(data.detectionFiltered.metadata.attributes)"
              >
                <div mat-line>{{ toStartCase(property.label).toUpperCase() }}</div>
                <div class="propertyName" mat-line>
                  {{ 'common.confidence' | t }} {{ property.confidence | fsNumber : '1.0-2' }}%
                </div>
              </mat-list-item>
            </ng-container>

            <ng-container *ngSwitchDefault>
              <mat-list-item
                *ngFor="let property of formatFields(data.detectionFiltered.metadata) | keyvalue"
              >
                <ng-container ngProjectAs="[mat-line]" *ngIf="isArray(property.value)">
                  <ng-container *ngFor="let item of property.value">
                    <ng-container *ngIf="isObject(item)">
                      <ng-container *ngFor="let itemObject of item | keyvalue">
                        <div mat-line>{{ itemObject.value }}</div>
                        <div class="propertyName property-name-key" mat-line>
                          {{ toStartCase(itemObject.key) }}
                        </div>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngIf="!isObject(item)">
                      {{ item }}
                    </ng-container>
                  </ng-container>
                </ng-container>
                <ng-container ngProjectAs="[mat-line]" *ngIf="!isArray(property.value)">
                  <ng-container
                    ngProjectAs="[mat-line]"
                    *ngIf="property.key === 'vehicleLicensePlate'; else default"
                  >
                    <div mat-line>
                      {{ property.value[0]?.plate[0]?.label.toUpperCase() }} -
                      {{ property.value[0]?.state[0]?.label.toUpperCase() }}
                    </div>
                    <div class="propertyName" mat-line>{{ toStartCase(property.key) }}</div>
                  </ng-container>

                  <ng-template ngProjectAs="[mat-line]" #default>
                    <div mat-line>{{ property.value }}</div>
                    <div class="propertyName" mat-line>{{ toStartCase(property.key) }}</div>
                  </ng-template>
                </ng-container>
              </mat-list-item>
            </ng-container>
          </ng-container>
        </ng-container>
      </mat-list>
    </mat-dialog-content>
  </div>
</div>
<mat-dialog-actions class="detection-footer">
  <div class="timestamp">
    <sn-icon size="sm">schedule</sn-icon>
    <span>{{ data.detection.timestamp | fsFormatDate : 'medium' }}</span>
  </div>
  <div class="actions">
    <button
      [matTooltip]="'map.detectionDetails.reportAsIncorrectDetection' | t"
      mat-button
      color="warn"
      (click)="incorrectSentryResult()"
    >
      {{ 'common.reportDetection' | t }}
    </button>
    <button mat-button color="accent" (click)="toggleImage()">
      {{ isZoomed ? ('map.detectionDetails.fullImage' | t) : ('map.detectionDetails.focusDetection' | t) }}
    </button>
  </div>
</mat-dialog-actions>
